module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/assessment_achievements/1_81adc032fc224d978f99cc012c6f1e7e.png";